module.exports = __webpack_public_path__ + "static/science-879fe18e582461b25de6dca29383c477.png";